
import state from './state'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import { createStore } from 'vuex'

export default createStore({
  state,
  mutations,
  actions,
  getters,
  // 开启严格模式，确保状态变更只能通过 mutations
  strict: process.env.NODE_ENV !== 'production'
})